import React from "react";
import { Text, View } from "@react-pdf/renderer";

export const formatParagraphText = (rawText = "", pdfMode = false) => {
  if (!rawText) return null;

  // Normalize newlines and remove null characters or extra symbols like ASCII 31
  const normalized = rawText
    .replace(/\u001f/g, '') // remove ASCII "unit separator"
    .replace(/\r\n|\r/g, '\n') // normalize line breaks
    .trim();

  const lines = normalized.split('\n').map(line => line.trim());

  if (pdfMode) {
    return (
      <View style={{ marginTop: 8 }}>
        {lines.map((line, idx) => (
          <Text key={idx} style={{ marginBottom: 4 }}>
            {line}
          </Text>
        ))}
      </View>
    );
  }

  // Web (DOM) rendering
  return (
    <div style={{ marginTop: 8 }}>
      {lines.map((line, idx) => (
        <p key={idx} style={{ marginBottom: "0.5rem" }}>
          {line}
        </p>
      ))}
    </div>
  );
};
